export default function (error, vueCompoment, prefix) {
  if (typeof error === 'string') {
    console.log(error)
    vueCompoment.$message.error(error)
  } else if ((error.response != null) || (error.response.data != null)) {
    console.log(error.response)
    if (typeof error.response.data === 'string') { // my simple errors (или лень было, или такие как защита от дурака по ограничению на вводимые данные
      if (error.response.data === '') vueCompoment.$message.error((prefix != null ? prefix : 'Ошибка при попытке обратиться к серверу:') + ' Статус: ' + error.response.status + ', Ошибка: ' + error.response.statusText)
      else vueCompoment.$message.error(error.response.data)
    } else if (error.response.data.error != null) { // my errors
      vueCompoment.$message.error((prefix != null ? prefix : 'Ошибка при попытке обратиться к серверу:') + ' Статус: ' + error.response.status + ', Код ошибки: ' + error.response.data.code + ', Ошибка: ' + error.response.data.error)
    } else if (error.response.data.message != null) { // exception. response.data={stack, message}
      vueCompoment.$message.error((prefix != null ? prefix : 'Ошибка при попытке обратиться к серверу:') + ' Статус: ' + error.response.status + ', Exception message: ' + error.response.data.message)
    } else vueCompoment.$message.error((prefix != null ? prefix : 'Ошибка при попытке обратиться к серверу:') + ' Статус: ' + error.response.status + ', Ошибка: ' + JSON.stringify(error.response.data))
  } else {
    console.log(error)
    vueCompoment.$message.error((prefix != null ? prefix : 'Ошибка при попытке обратиться к серверу:') + ' Не доступен или разорвал связь при данном обращении')
  }
}



// WEBPACK FOOTER //
// ./src/technical/serverErrorHandling.js